window.CKEDITOR_BASEPATH = './build/ckeditor/';